export const selectCommonSize = (state) => state.mainReducer.productCommonSize;
